console.log("custom.js");
function RenderPreOrder(preOrderElement, preOrderButton) {
  if (!preOrderElement) return;
  const dataUrl = preOrderElement.getAttribute("data-url");

  if (dataUrl) {
    fetch(dataUrl)
      .then((response) => response.json())
      .then((data) => {
        // Store response in a variable
        let jsonResponsePreOrder = data;

        let PreOrderVariant = jsonResponsePreOrder.variants.find(
          (variant) =>
            variant.title ==
            document
              .querySelector(".seletect-variant-id")
              .getAttribute("data-title")
        );
        document.querySelector('.custom-pre-order [name="id"]').value =
          PreOrderVariant.id;

        if (preOrderButton) {
          if (PreOrderVariant !== undefined) {
            preOrderButton.disabled =
              !PreOrderVariant || !PreOrderVariant.available;
            let PriceText_ComparePrice =
              PreOrderVariant.compare_at_price > 0
                ? '<compare-at-price class="h6 text-subdued line-through">' +
                  formatMoney(
                    PreOrderVariant.compare_at_price,
                    currencyFormat
                  ) +
                  "</compare-at-price>"
                : "";
            let PriceText =
              "<buy-price>" +
              PriceText_ComparePrice +
              ' <sale-price class="h6 text-subdued">' +
              formatMoney(PreOrderVariant.price, currencyFormat) +
              "</sale-price></buy-price>";
            let PreOrderSubText =
              '<div class="instock-buy-button-text">' +
              preOrderButton.getAttribute("data-subtext") +
              "</div>";
            preOrderButton.innerHTML = PreOrderVariant.available
              ? '<div class="btn_inner"><span>Pre Order</span></div>' +
                PreOrderSubText
              : window.themeVariables.strings.soldOutButton;
          } else {
            preOrderButton.disabled = true;
            preOrderButton.innerHTML =
              window.themeVariables.strings.soldOutButton;
          }
          preOrderButton.addEventListener("click", function () {
            document
              .querySelector('form.custom-pre-order button[type="submit"]')
              .click();
          });
        }

        // You can use jsonResponse as needed here
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}

function RenderCollectionslider() {
  if (document.querySelector(".collectionSwiper")) {
    console.log("RenderCollectionslider");
    const varientSlider = new Swiper(".collectionSwiper", {
      slidesPerView: 1,
      speed: 500,
      delay: 100,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

function RederSateches() {
  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document
    .querySelectorAll(".mobile_quickbuy_trigger")
    .forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        this.closest(".product-card").classList.add("quickbuy-active");
      });
    });

  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document.querySelectorAll(".close_button").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      this.closest(".product-card").classList.remove("quickbuy-active");
    });
  });

  // Function to check screen width
  function isScreenAbove700px() {
    return window.innerWidth > 700;
  }

  // Get all product cards
  var productCards = document.querySelectorAll(".product-card");

  // Iterate through each product card
  productCards.forEach(function (card) {
    var figure = card.querySelector(".product-card__figure");
    var swatches = card.querySelector(".swatches_kopstorm");

    // Function to handle hover in
    function handleHoverIn() {
      if (isScreenAbove700px()) {
        swatches.style.display = "block";
      }
    }

    // Function to handle hover out
    function handleHoverOut() {
      if (isScreenAbove700px()) {
        swatches.style.display = "none";
      }
    }

    // Add event listener for hover in
    figure.addEventListener("mouseover", handleHoverIn);

    // Add event listener for hover out
    figure.addEventListener("mouseout", handleHoverOut);
  });
}

function RenderTagLinks(){
   const facetform = document.querySelectorAll('facets-form form');
document.querySelectorAll(".collection_product_tags a").forEach((taglink) => {
    taglink.addEventListener("click", (e) => {
        e.preventDefault();
        if(facetform){
            facetform.forEach((form) => {
                form.setAttribute('action', taglink.getAttribute('href'));
            })
        }
        const checkbox = document.querySelector('[name="filter.v.availability"]');

if (checkbox) {
 // checkbox.checked = false; // Toggle or set true/false
  checkbox.dispatchEvent(new Event("change", { bubbles: true }));
}
    })
})
}
document.addEventListener("DOMContentLoaded", function (event) {
  RenderCollectionslider();
  RederSateches();
   RenderTagLinks();
setTimeout(function(){
   RederSateches();
}, 3000);
  if (document.querySelector(".varient_slider")) {
    /* const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 4.5,
      spaceBetween: 5,
      // autoplay: true,
      speed: 500,
      delay: 100,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 5.5,
        },
        992: {
          slidesPerView: 7.5,
        },
        1200: {
          slidesPerView: 7.5,
        },
      },
    });*/
    const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 6.5, // Default for mobile
      spaceBetween: 3,
      freeMode: true, // Enables free scrolling
      freeModeMomentum: true, // Adds momentum for natural feel
      freeModeMomentumRatio: 1, // Controls momentum strength
      freeModeMomentumVelocityRatio: 0.5, // Controls speed of momentum
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // Tablet and up: maintain your original settings
        768: {
          slidesPerView: 7.5,
          spaceBetween: 5,
          freeMode: false, // Disable free mode on larger screens
        },
        992: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
        1200: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
      },
      // Optional: Disable navigation buttons on mobile if not needed
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            //this.navigation.destroy();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            // this.navigation.destroy();
          } else {
            // this.navigation.init();
          }
        },
      },
    });

    // Get all slides as an array
    const slides = Array.from(varientSlider.slides);

    // Sort slides based on data-index attribute
    slides.sort((a, b) => {
      const indexA = parseInt(a.getAttribute("data-index")) || 6;
      const indexB = parseInt(b.getAttribute("data-index")) || 6;
      return indexA - indexB; // Ascending order (use indexB - indexA for descending)
    });

    // Remove all existing slides
    varientSlider.removeAllSlides();

    // Append sorted slides
    slides.forEach((slide) => varientSlider.appendSlide(slide));

    // Update Swiper to reflect changes
    varientSlider.update();

    document.querySelector(".cust_swatches").removeAttribute("style");
    const activeSlideIndex = Array.from(
      document.querySelectorAll(".varient_slider .swiper-slide")
    ).findIndex((slide) => slide.classList.contains("activeslide"));
    //varientSlider.slideTo(activeSlideIndex);
  }

  let preOrderElement = document.querySelector(".custom-pre-order");

  const addToCartButton = document.querySelector(
    'product-form button[type="submit"]'
  );
  document.addEventListener("variant:change", function (event) {
    let preOrderButton = document.querySelector(
      '.custom-pre-order button[type="button"]'
    );
    RenderPreOrder(preOrderElement, preOrderButton);
    /*      if (event.detail.variant["available"]) {
    addToCartButton.classList.remove("addtocart-soldout");
    addToCartButton.parentElement.classList.add("main-product-is-not-available");
} else {
    addToCartButton.classList.add("addtocart-soldout");
    addToCartButton.parentElement.classList.remove("main-product-is-not-available");

}*/
  });

  document.addEventListener("facet:update", function (event) {
    console.log("facet");
      setTimeout(function () {
     RenderTagLinks();
         }, 1500);
    setTimeout(function () {
      RenderCollectionslider();
      RederSateches();
      
    }, 3000);
  });

  if (document.querySelector(".pdp-upsells")) {
    const pdpUpsellsSwiper = new Swiper(".pdp-upsells", {
      slidesPerView: 1.5,
      spaceBetween: 20, // You can adjust this for spacing between slides
      loop: true, // Equivalent to infinite scrolling
      navigation: {
        nextEl: ".pdp-upsells-next",
        prevEl: ".pdp-upsells-prev",
      },
      breakpoints: {
        499: {
          slidesPerView: 1.05,
        },
        768: {
          slidesPerView: 2.05,
        },
        1024: {
          slidesPerView: 1.5,
        },
      },
    });
  }

  if (preOrderElement) {
    let preOrderButton = document.querySelector(
      '.custom-pre-order button[type="button"]'
    );

    RenderPreOrder(preOrderElement, preOrderButton);
  }
});

// Feature Fact Swiper JS
if (document.querySelector(".feature_fact_slider")) {
var swiper = new Swiper(".feature_fact_slider", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    576: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.4,
      spaceBetween: 10,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
  },
});
  document.querySelector(".features_fact").removeAttribute("style");
}
if (document.querySelector(".upsell-img-slider")) {
var swiper = new Swiper(".upsell-img-slider", {
  speed: 300,
  delay: 20,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
}
const showFeatureFacts = document.querySelectorAll(".show_ff_content");

if (showFeatureFacts) {
  showFeatureFacts.forEach((button) => {
    button.addEventListener("click", function () {
      button.parentNode.classList.toggle("active");
    });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  const productSelect = document.querySelectorAll('.product_list_upsell');

  // Function to fetch product variants
  async function fetchProductVariants(productHandle) {
    try {
      // Shopify AJAX API endpoint to fetch product data
      const response = await fetch(`${productHandle}.js`);
      const product = await response.json();
      return product.variants;
    } catch (error) {
      console.error('Error fetching product variants:', error);
      return [];
    }
  }

  // Function to update variant dropdown
  function updateVariantDropdown(variants, variantSelectOption) {
    // Clear existing options
    const variantSelect = variantSelectOption.nextElementSibling;
    console.log(variantSelect);
    if (!variantSelect) return; // Ensure the select element exists
    variantSelect.innerHTML = '';

    // Populate new options
    variants.forEach(variant => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.disabled = true;
        option.style.textDecoration = 'line-through';
        option.textContent += ' (sold out)';
      }
      variantSelect.appendChild(option);
    });
  }

  // Event listener for product selection change
  if(productSelect){
  productSelect.forEach(select => {
    select.addEventListener('change', async () => {
      const selectedProductHandle = select.value;
      if (selectedProductHandle) {
        const variants = await fetchProductVariants(selectedProductHandle);
        updateVariantDropdown(variants, select);
      }
    });
  });
 
  } 



   document.addEventListener("recommendations:change", function (event) {

console.log("recommendations changed");
   })




});



